import * as Sentry from '@sentry/react'
import { captureConsoleIntegration } from '@sentry/integrations'
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './global.css'
import { IS_PROD } from './util/Constants'
import { scrubBreadcrumb, scrubEvent } from './util/SentryScrub'

if (IS_PROD) {
  Sentry.init({
    dsn: 'https://55021c91df5eef7cbbf78d01e56c83df@o4506811525824512.ingest.sentry.io/4506811527200768',
    // Nothing personal leaves the browser: no default PII, masked replays and
    // scrubbed events and breadcrumbs (see util/SentryScrub.ts).
    sendDefaultPii: false,
    integrations: [
      captureConsoleIntegration({ levels: ['error'] }),
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        maskAllInputs: true,
        blockAllMedia: true
      })
    ],
    beforeSend: event => scrubEvent(event),
    beforeBreadcrumb: breadcrumb => scrubBreadcrumb(breadcrumb),
    // Performance Monitoring
    tracesSampleRate: 0.2,
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost'],
    // Session Replay (masked): 10% of sessions, every session with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
  })
}

console.info(`
██████╗  █████╗ ██████╗  ██████╗ ███╗   ███╗
██╔══██╗██╔══██╗██╔══██╗██╔═══██╗████╗ ████║
██████╔╝███████║██║  ██║██║   ██║██╔████╔██║
██╔══██╗██╔══██║██║  ██║██║   ██║██║╚██╔╝██║
██║  ██║██║  ██║██████╔╝╚██████╔╝██║ ╚═╝ ██║
╚═╝  ╚═╝╚═╝  ╚═╝╚═════╝  ╚═════╝ ╚═╝     ╚═╝
Welcome to Radom!
Build: ${process.env.RADOM_BUILD_VERSION}
`)

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(document.getElementById('app')!)
root.render(<App />)
